import { render } from "./SolutionsSection.vue?vue&type=template&id=5c7a937c&scoped=true"
const script = {}

import "./SolutionsSection.vue?vue&type=style&index=0&id=5c7a937c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c7a937c"]])

export default __exports__